<template>
  <div
    class="notification"
    :class="[`notification-${data.color}`]"
    :data-id="id"
  >
    <div class="notification__content">
      <h4 class="notification__title">
        <span>{{ data.title }}</span>
        <span class="notification__title-date">{{ data.endDate }}</span>
      </h4>

      <router-link class="notification__auto" :to="autoLink">
        {{ `${data.car.number} ${data.car.brand} ${data.car.model}` }}
      </router-link>

      <p class="notification__description">
        {{ data.body }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    autoLink() {
      switch (this.data.type) {
        case 'expiryOsgpo':
        case 'expiryKasko':
        case 'closeCheckup':
          return `/autos/${this.data.car.id}/info`;

        case 'oil_change_next_date':
        case 'brake_pads_change_next_date':
        case 'coolant_change_next_date':
        case 'brake_fluid_change_next_date':
        case 'air_filter_change_next_date':
        case 'auto_transmission_oil_change_next_date':
        case 'manual_transmission_oil_change_next_date':
        case 'steering_oil_change_next_date':
        case 'spark_plugs_change_next_date':
        case 'fuel_filter_change_next_date':
        case 'clutch_change_next_date':
        case 'timing_belt_change_next_date':
          return `/autos/${this.data.car.id}/internal-maintenance`;

        default:
          return `/autos/${this.data.car.id}/internal-maintenance`;
      }
    },
  },
};
</script>

<style lang="scss">
.notification {
  position: relative;
  max-width: 320px;
  padding-left: 3px;
  border-radius: 5px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  &::after {
    content: '';
    position: absolute;
    top: 10px;
    right: 10px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: inherit;
  }

  &-red {
    background-color: #ff5959;
  }

  &-yellow {
    background-color: #ffdf52;
  }

  &-green {
    background-color: #51f565;
  }

  &__content {
    padding: 10px;
    border-radius: 5px;
    background-color: #fff;
  }

  &__title {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;

    &-date {
      padding: 2px 5px;
      font-size: 13px;
      color: #777;
      margin-left: 7px;
      border-radius: 5px;
      background-color: #eee;
    }
  }

  &__auto {
    font-size: 13px;
    font-style: italic;
    text-decoration: none;
    color: #777 !important;

    &:hover {
      text-decoration: underline;
    }
  }

  &__description {
    margin-bottom: 0 !important;
    font-size: 15px;
  }
}
</style>
